import { render } from "./DrillDateHistoryDetailView.vue?vue&type=template&id=80713f18&scoped=true"
import script from "./DrillDateHistoryDetailView.vue?vue&type=script&lang=js"
export * from "./DrillDateHistoryDetailView.vue?vue&type=script&lang=js"

import "./DrillDateHistoryDetailView.vue?vue&type=style&index=0&id=80713f18&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80713f18"]])

export default __exports__